export const JUPAS_SURVEY_CANDIDATE_CONFIRM_KEY = 'edvise:jupas-survey-candidate-confirmed';

export function hasJupasSurveyCandidateConfirmation() {
  try {
    return window.sessionStorage.getItem(JUPAS_SURVEY_CANDIDATE_CONFIRM_KEY) === '1';
  } catch {
    return false;
  }
}

export function setJupasSurveyCandidateConfirmed() {
  try {
    window.sessionStorage.setItem(JUPAS_SURVEY_CANDIDATE_CONFIRM_KEY, '1');
  } catch {
    // ignore storage failures
  }
}
